import { render, staticRenderFns } from "./bannerA.vue?vue&type=template&id=5b908c91&"
import script from "./bannerA.vue?vue&type=script&lang=js&"
export * from "./bannerA.vue?vue&type=script&lang=js&"
import style0 from "./bannerA.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports